// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { IAllEnumData } from './EnumClass';
import abilities from './Ability/data';
import { ABILITIES } from './Ability';
import staff_positions from './StaffPosition/data';
import { STAFF_POSITIONS } from './StaffPosition';
import staff_teams from './StaffTeam/data';
import { STAFF_TEAMS } from './StaffTeam';
import services from './Service/data';
import { SERVICES } from './Service';
import products from './Product/data';
import { PRODUCTS } from './Product';
import subscription_types from './SubscriptionType/data';
import { SUBSCRIPTION_TYPES } from './SubscriptionType';
import subscription_states from './SubscriptionState/data';
import { SUBSCRIPTION_STATES } from './SubscriptionState';
import vocab_types from './VocabType/data';
import { VOCAB_TYPES } from './VocabType';
import paragraph_styles from './ParagraphStyle/data';
import { PARAGRAPH_STYLES } from './ParagraphStyle';
import quiz_types from './QuizType/data';
import { QUIZ_TYPES } from './QuizType';
import parts_of_speech from './PartOfSpeech/data';
import { PARTS_OF_SPEECH } from './PartOfSpeech';
import visibilities from './Visibility/data';
import { VISIBILITIES } from './Visibility';
import language_proficiencies from './LanguageProficiency/data';
import { LANGUAGE_PROFICIENCIES } from './LanguageProficiency';
import rtc_bot_types from './RtcBotType/data';
import { RTC_BOT_TYPES } from './RtcBotType';
import countries from './Country/data';
import { COUNTRIES } from './Country';
import teacher_change_reasons from './TeacherChangeReason/data';
import { TEACHER_CHANGE_REASONS } from './TeacherChangeReason';
import password_types from './PasswordType/data';
import { PASSWORD_TYPES } from './PasswordType';
import inflection_types from './InflectionType/data';
import { INFLECTION_TYPES } from './InflectionType';
import attendance_statuses from './AttendanceStatus/data';
import { ATTENDANCE_STATUSES } from './AttendanceStatus';
import booking_cancellation_types from './BookingCancellationType/data';
import { BOOKING_CANCELLATION_TYPES } from './BookingCancellationType';
import payment_override_reasons from './PaymentOverrideReason/data';
import { PAYMENT_OVERRIDE_REASONS } from './PaymentOverrideReason';
import payment_statuses from './PaymentStatus/data';
import { PAYMENT_STATUSES } from './PaymentStatus';
import languages from './Language/data';
import { ALL_LANGUAGES } from './Language';
import cancellation_reasons from './CancellationReason/data';
import { CANCELLATION_REASONS } from './CancellationReason';
import dictionary_tags from './DictionaryTag/data';
import { DICTIONARY_TAGS } from './DictionaryTag';
import auth_providers from './AuthProvider/data';
import { AUTH_PROVIDERS } from './AuthProvider';
import bibliography_types from './BibliographyType/data';
import { BIBLIOGRAPHY_TYPES } from './BibliographyType';
import license_partners from './LicensePartner/data';
import { LICENSE_PARTNERS } from './LicensePartner';
import copyright_licenses from './CopyrightLicense/data';
import { COPYRIGHT_LICENSES } from './CopyrightLicense';
import site_features from './SiteFeature/data';
import { ALL_SITE_FEATURES } from './SiteFeature';
import issue_statuses from './IssueStatus/data';
import { ISSUE_STATUSES } from './IssueStatus';
import alias_timezones from './AliasTimezones/data';
import { ALIAS_TIMEZONES } from './AliasTimezones';

export const ALL_ENUM_DATA: IAllEnumData = {
  abilities: {
    raw: abilities,
    list: ABILITIES,
    endpoint: 'abilities',
    omitDataFields: [],
  },
  staff_positions: {
    raw: staff_positions,
    list: STAFF_POSITIONS,
    endpoint: 'staff_positions',
    omitDataFields: [],
  },
  staff_teams: {
    raw: staff_teams,
    list: STAFF_TEAMS,
    endpoint: 'staff_teams',
    omitDataFields: [],
  },
  services: {
    raw: services,
    list: SERVICES,
    endpoint: 'services',
    omitDataFields: [],
  },
  products: {
    raw: products,
    list: PRODUCTS,
    endpoint: 'products',
    omitDataFields: [],
  },
  subscription_types: {
    raw: subscription_types,
    list: SUBSCRIPTION_TYPES,
    endpoint: 'subscription_types',
    omitDataFields: [],
  },
  subscription_states: {
    raw: subscription_states,
    list: SUBSCRIPTION_STATES,
    endpoint: 'subscription_states',
    omitDataFields: [],
  },
  vocab_types: {
    raw: vocab_types,
    list: VOCAB_TYPES,
    endpoint: 'vocab_types',
    omitDataFields: [],
  },
  paragraph_styles: {
    raw: paragraph_styles,
    list: PARAGRAPH_STYLES,
    endpoint: 'paragraph_styles',
    omitDataFields: [],
  },
  quiz_types: {
    raw: quiz_types,
    list: QUIZ_TYPES,
    endpoint: 'quiz_types',
    omitDataFields: [],
  },
  parts_of_speech: {
    raw: parts_of_speech,
    list: PARTS_OF_SPEECH,
    endpoint: 'parts_of_speech',
    omitDataFields: [],
  },
  visibilities: {
    raw: visibilities,
    list: VISIBILITIES,
    endpoint: 'visibilities',
    omitDataFields: [],
  },
  language_proficiencies: {
    raw: language_proficiencies,
    list: LANGUAGE_PROFICIENCIES,
    endpoint: 'language_proficiencies',
    omitDataFields: [],
  },
  rtc_bot_types: {
    raw: rtc_bot_types,
    list: RTC_BOT_TYPES,
    endpoint: 'rtc/bot_types',
    omitDataFields: [],
  },
  countries: {
    raw: countries,
    list: COUNTRIES,
    endpoint: 'countries',
    omitDataFields: ['name'],
  },
  teacher_change_reasons: {
    raw: teacher_change_reasons,
    list: TEACHER_CHANGE_REASONS,
    endpoint: 'teacher_change_reasons',
    omitDataFields: [],
  },
  password_types: {
    raw: password_types,
    list: PASSWORD_TYPES,
    endpoint: 'password_types',
    omitDataFields: [],
  },
  inflection_types: {
    raw: inflection_types,
    list: INFLECTION_TYPES,
    endpoint: 'inflection_types',
    omitDataFields: [],
  },
  attendance_statuses: {
    raw: attendance_statuses,
    list: ATTENDANCE_STATUSES,
    endpoint: 'attendance_statuses',
    omitDataFields: [],
  },
  booking_cancellation_types: {
    raw: booking_cancellation_types,
    list: BOOKING_CANCELLATION_TYPES,
    endpoint: 'booking_cancellation_types',
    omitDataFields: [],
  },
  payment_override_reasons: {
    raw: payment_override_reasons,
    list: PAYMENT_OVERRIDE_REASONS,
    endpoint: 'payment_override_reasons',
    omitDataFields: [],
  },
  payment_statuses: {
    raw: payment_statuses,
    list: PAYMENT_STATUSES,
    endpoint: 'payment_statuses',
    omitDataFields: [],
  },
  languages: {
    raw: languages,
    list: ALL_LANGUAGES,
    endpoint: 'languages',
    omitDataFields: [],
  },
  cancellation_reasons: {
    raw: cancellation_reasons,
    list: CANCELLATION_REASONS,
    endpoint: 'cancellation_reasons',
    omitDataFields: [],
  },
  dictionary_tags: {
    raw: dictionary_tags,
    list: DICTIONARY_TAGS,
    endpoint: 'dictionary_tags',
    omitDataFields: [],
  },
  auth_providers: {
    raw: auth_providers,
    list: AUTH_PROVIDERS,
    endpoint: 'auth_providers',
    omitDataFields: [],
  },
  bibliography_types: {
    raw: bibliography_types,
    list: BIBLIOGRAPHY_TYPES,
    endpoint: 'bibliography_types',
    omitDataFields: [],
  },
  license_partners: {
    raw: license_partners,
    list: LICENSE_PARTNERS,
    endpoint: 'license_partners',
    omitDataFields: [],
  },
  copyright_licenses: {
    raw: copyright_licenses,
    list: COPYRIGHT_LICENSES,
    endpoint: 'copyright_licenses',
    omitDataFields: [],
  },
  site_features: {
    raw: site_features,
    list: ALL_SITE_FEATURES,
    endpoint: 'site_features',
    omitDataFields: [],
  },
  issue_statuses: {
    raw: issue_statuses,
    list: ISSUE_STATUSES,
    endpoint: 'issue_statuses',
    omitDataFields: [],
  },
  alias_timezones: {
    raw: alias_timezones,
    list: ALIAS_TIMEZONES,
    endpoint: 'alias_timezones',
    omitDataFields: [],
  },
};
